import { Box, Stack, Typography } from "@mui/material"
import { NumericFormat } from "react-number-format"
import { FC, SpecialTag } from ".."
import StickyTripBannerWrapper from "./StickyTripBannerWrapper"
import TripCTA from "./TripCTA"

type StickyTripBannerProps = {
  duration: string
  price: number
  prefix: string
  savings: string
  onClick: () => void
}

const StickyTripBannerMobile: FC<StickyTripBannerProps> = ({
  duration,
  price,
  prefix,
  savings,
  onClick,
}) => {
  const isPriceAvailable = price && price > 200

  return (
    <StickyTripBannerWrapper>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={4} width="100%">
        <Box display="flex" alignItems="center" gap={4}>
          {savings && (
            <SpecialTag
              sx={{
                position: "relative",
                top: "unset",
                left: "unset",
                width: "fit-content",
                padding: "6px 8px",
              }}
            />
          )}
          <Stack>
            {duration && (
              <Typography
                variant="body.md"
                fontSize="14px"
                fontWeight={600}
                textTransform="uppercase"
                sx={(theme) => ({ color: theme.palette["neutral.100"].main })}
              >
                {duration}
              </Typography>
            )}
            {isPriceAvailable ? (
              <Box
                sx={(theme) => ({
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: theme.palette["neutral.100"].main,
                })}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "140%",
                  }}
                >
                  <NumericFormat
                    value={price}
                    displayType="text"
                    thousandSeparator
                    prefix={prefix}
                    decimalScale={0}
                  />
                </span>
              </Box>
            ) : (
              <Typography
                variant="body.md"
                sx={(theme) => ({
                  fontSize: "14px!important",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "140%",
                  color: theme.palette["neutral.100"].main,
                })}
              >
                Please Inquire
              </Typography>
            )}
          </Stack>
        </Box>
        <TripCTA onClick={onClick} />
      </Box>
    </StickyTripBannerWrapper>
  )
}

export default StickyTripBannerMobile
